import {
  createRouter,
  type ParsedLocation,
  type Router,
  RouterProvider,
} from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { routeTree } from "./routeTree.gen";
import "./index.css";
import { OnlineUsersIndicatorElement } from "@nijiurachan/js/elements/online-users-indicator";
import { initCookieStore } from "@nijiurachan/js/util/cookie-store";
import { SettingsStoreContext } from "./features/settings/hooks";
import { createSettingsStore } from "./features/settings/stores";

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: Router<typeof routeTree>;
  }
}

if (!window.cookieStore) {
  await initCookieStore();
}

OnlineUsersIndicatorElement.define();

createRoot(document.getElementById("root") as HTMLElement).render(makeRoot());

/** ルート要素を作成 */
function makeRoot(): React.ReactElement {
  const router = createRouter({
    routeTree,
    scrollRestoration: true,
    basepath: import.meta.env.BASE_PATH,
    getScrollRestorationKey: ({ pathname, state }: ParsedLocation) =>
      shouldRestoreScrollAt(pathname) ? pathname : (state.__TSR_key as string),
  });

  const settingsStore = createSettingsStore();

  return (
    <StrictMode>
      <SettingsStoreContext value={settingsStore}>
        <RouterProvider router={router} />
      </SettingsStoreContext>
    </StrictMode>
  );
}

/** スクロールを記憶してほしいページかどうか判定 */
function shouldRestoreScrollAt(pathname: string): boolean {
  return pathname === "/" || pathname.startsWith("/thread/");
}
